export default {
  props: {
    tableShouldBeReloaded: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    reload () {}
  },
  watch: {
    tableShouldBeReloaded (value) {
      if (value === true) {
        this.reload()
      }
    }
  },
}
